import React, { useEffect, useState } from 'react';
import { CheckCircle, Clock, AlertCircle } from 'lucide-react';
import { useApiHandler } from '../../../utils/apiHandler';

const TaskStatus = ({ status }) => {
  const statusConfig = {
    completed: { icon: CheckCircle, color: 'text-green-500', bg: 'bg-green-50' },
    inProgress: { icon: Clock, color: 'text-blue-500', bg: 'bg-blue-50' },
    pending: { icon: AlertCircle, color: 'text-yellow-500', bg: 'bg-yellow-50' },
  };

  const { icon: Icon, color, bg } = statusConfig[status] || { icon: AlertCircle, color: 'text-gray-500', bg: 'bg-gray-50' };
  return (
    <div className={`flex items-center ${color} ${bg} px-2 py-1 rounded-full text-xs`}>
      <Icon className="w-3 h-3 mr-1" />
      <span className="capitalize">{status || 'Unknown'}</span>
    </div>
  );
};

const TaskList = () => {
  const [tasks, setTasks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const apiHandler = useApiHandler();

  useEffect(() => {
    const fetchTasks = async () => {
      try {
        const response = await apiHandler.get('/employee/task-list');
        setTasks(response.data.data);
        setLoading(false);
      } catch (err) {
        setError(err.response?.data?.message || 'Failed to fetch tasks');
        setLoading(false);
      }
    };

    fetchTasks();
  }, []);

  if (loading) {
    return <div className="p-6">Loading...</div>;
  }

  if (error) {
    return <div className="p-6 text-red-500">{error}</div>;
  }

  if (tasks.length === 0) {
    return <div className="p-6">No tasks available</div>;
  }

  return (
    <div className="bg-white rounded-xl shadow-sm border border-gray-100">
      <div className="p-6 border-b border-gray-100">
        <h2 className="text-lg font-semibold text-gray-900">Current Tasks</h2>
      </div>
      <div className="divide-y divide-gray-100">
        {tasks.map((task) => (
          <div key={task.taskId} className="p-6">
            <div className="flex justify-between items-start mb-2">
              <h3 className="text-sm font-medium text-gray-900">{task.taskDetails}</h3>
              <TaskStatus status={task.status.toLowerCase()} />
            </div>
            <div className="flex items-center justify-between text-sm text-gray-500">
              <div className="flex items-center space-x-4">
                <span>Assigned By: {task.assignedBy}</span>
                <span>Due: {task.date}</span>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TaskList;
